// extracted by mini-css-extract-plugin
export default {"component":"FootButton_component__0ifCu"};